export enum Routes {
  AYUDA = 'ayuda',
  PREGUNTAS = 'cuenta/preguntas',
  DEVOLUCION = 'devolucion',
  RESERVAS = 'cuenta/reservas',
}
